import { inject, Injectable } from '@angular/core';
import { WINDOW } from '@common/window.provider';

@Injectable({ providedIn: 'root' })
export class QueryParamsService {
  private readonly window = inject(WINDOW);

  get queryParams(): URLSearchParams {
    return new URLSearchParams(this.window.location.search);
  }

  getParam(name: string): string | null {
    return this.queryParams.get(name);
  }

  getAll(name: string): string[] {
    return this.queryParams.getAll(name);
  }
}
